import type { ShipmentStatus } from '../enums/ShipmentStatus'

export class ShipmentMiniEntity {
  id?: string
  orderId?: string
  driverId?: number
  driverFullName?: string | null
  driverAvatarImagePath?: string | null
  jobId?: string
  status?: ShipmentStatus
  orderBranchSid?: string | null
  orderBranchName?: string | null
  orderUserId?: string
  orderUserDisplayName?: string | null
  orderUserPhoneNumber?: string | null
  regionId?: number
  regionName?: string | null
  createdAt?: string
  statusSetOn?: string
  orderReferenceCode?: string
  driverEarning?: number
}
